import type { ComponentProps } from 'react';
import React from 'react';
import { MultiComboBox } from '@itandi/itandi-bb-ui';
import { useFormContext } from 'react-hook-form';
import type { DealSearchCondition } from '~/models/Deal';
import type { Status } from '~/models/Status';
import {
  convertToComboBoxOption,
  defaultSelectedOption
} from '~/models/Status';
import { CurrentFilter } from '~/components/deprecated/CurrentFilter';

type Props = {
  dealSearchCondition: DealSearchCondition;
  statuses: Status[];
};
type MultiComboBoxOption = Exclude<
  ComponentProps<typeof MultiComboBox>['options'][number],
  { group: string }
>;

export const StatusCombobox: React.FC<Props> = ({
  dealSearchCondition,
  statuses
}: Props) => {
  const { setValue } = useFormContext<DealSearchCondition>();
  const selectedStatuses = statuses.filter(
    ({ id }) => dealSearchCondition.statusId?.includes(id)
  );
  const [selectedStatusOptions, setSelectedStatusOptions] = React.useState<
    MultiComboBoxOption[]
  >(
    selectedStatuses.length > 0
      ? selectedStatuses.map((s: Status) => convertToComboBoxOption(s))
      : defaultSelectedOption(statuses)
  );
  const onChangeStatus = React.useCallback(
    (options: MultiComboBoxOption[]): void => {
      setSelectedStatusOptions(options);
      setValue(
        'statusId',
        options.map((option) => Number(option.value))
      );
    },
    [setValue]
  );
  const removeStatusOption = (index: number): void => {
    const removedOptions = selectedStatusOptions.filter((_, i) => i !== index);
    setSelectedStatusOptions(removedOptions);
    setValue(
      'statusId',
      removedOptions.map((option) => Number(option.value))
    );
  };
  const updatedOptions = selectedStatusOptions.map((option, index) => ({
    ...option,
    onClickClose: (): void => removeStatusOption(index)
  }));
  return (
    <>
      <MultiComboBox
        defaultValue={selectedStatusOptions}
        onChange={onChangeStatus}
        options={statuses.map((s: Status) => convertToComboBoxOption(s))}
        placeholder="ステータス"
        showOptions={false}
        value={selectedStatusOptions}
      />
      <CurrentFilter options={updatedOptions} scroll={false} />
    </>
  );
};
